/*@ngInject*/
const RuleConditionGroupController = function ($rootScope, $scope, $element, $stateParams, localization, ruleMediator, ruleUtil, umStudioConstant, ruleModel, ruleConditionType) {

    $element.addClass('ruleConditionGroup');

    localization.getTranslations().then(function (translations) {
        this.any = _.get(translations, 'ruleConditionGroup.any');
        this.all = _.get(translations, 'ruleConditionGroup.all');

        this.changeOperator = function (operator) {
            this.ruleConditionGroup.operator = operator;

            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.getOperatorText = function () {
            if (this.ruleConditionGroup && this.ruleConditionGroup.operator === 'and') {
                return this.all;
            } else {
                return this.any;
            }
        };

        this.addCondition = function (conditionType) {
            ruleMediator.addCondition(this.ruleConditionGroup, conditionType);

            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.addGroup = function () {
            ruleMediator.addGroup(this.ruleConditionGroup);

            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.deleteGroup = function () {
            this.onDeleteGroup({ruleConditionGroup: this.ruleConditionGroup});

            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.doDeleteSubcondition = function (subcondition) {
            ruleMediator.deleteSubcondition(this.ruleConditionGroup, subcondition);

            $rootScope.$broadcast(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED);
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.getCondition = function (condition) {
            if (this.isUnaryCondition(condition)) {
                return condition.subcondition;
            }

            return condition;
        };

        this.ruleConditionTypes = null;

        this.getConditionTypes = function () {
            var ruleConditionTypes = [];
            ruleMediator.getConditionTypes().then(function (result) {
                _.each(result, function (conditionType) {
                    if (conditionType.name === ruleConditionType.BINARY || conditionType.name === ruleConditionType.RAW) {
                        ruleConditionTypes.push(conditionType);
                    }
                }.bind(this));
            }.bind(this));

            this.ruleConditionTypes = ruleConditionTypes;
        };

        this.getConditionName = function (name) {
            return _.get(translations, 'ruleConditionGroup.' + name + 'Condition');
        };

        this.isUnaryCondition = function (subcondition) {
            if (subcondition) {
                var conditionType = ruleUtil.getConditionType(subcondition.objectUri);
                return conditionType === 'UnaryCondition';
            }
            return false;
        };

        this.isGroup = function (subcondition) {
            if (subcondition) {
                if (this.isUnaryCondition(subcondition)) {
                    return this.isGroup(subcondition.subcondition);
                } else if (ruleUtil.getConditionType(subcondition.objectUri) === 'CompositeCondition') {
                    return true;
                }
            }

            return false;
        };

        this.doToggleNegation = function (ruleCondition, isUnaryCondition) {
            var unaryCondition;
            if (isUnaryCondition) {
                unaryCondition = _.find(this.ruleConditionGroup.subconditions, function (subcondition) {
                    return this.isUnaryCondition(subcondition) && subcondition.subcondition === ruleCondition;
                }.bind(this));
                ruleCondition = ruleMediator.convertFromUnaryCondition(this.ruleConditionGroup, unaryCondition);
            } else {
                ruleCondition = ruleMediator.convertToUnaryCondition(this.ruleConditionGroup, ruleCondition);
            }

            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.createVariableValueList = function () {
            if (this.isTopLevel) {
                ruleMediator.createVariableValueList(this.ruleConditionGroup);
            }
        };

        $scope.$on(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED, function () {
            this.createVariableValueList();
        }.bind(this));

        this.createVariableValueList();
        this.getConditionTypes();
    }.bind(this));
};

angular.module('umCore')
    .controller('ruleConditionGroupController', RuleConditionGroupController);
